import { TemplateCustomizationHint } from '@/core/components/profile-templates/template-customization-hint';
import type { ProfileTemplateFieldKey } from '@/core/lib/profile-template-fields';

type FieldOverrideDisplay = {
  customized: boolean;
  templateValue?: string;
  templateDetails?: Array<{
    label: string;
    value: string;
  }>;
};

type ProfileEditFieldOverrideHintProps = {
  fieldKey: ProfileTemplateFieldKey;
  getFieldOverrideDisplay: (
    key: ProfileTemplateFieldKey,
  ) => FieldOverrideDisplay;
  overrideHintMessage: string;
  resetLabel: string;
  templateValueLabel: string;
  onReset: (key: ProfileTemplateFieldKey) => void;
};

export function ProfileEditFieldOverrideHint({
  fieldKey,
  getFieldOverrideDisplay,
  overrideHintMessage,
  resetLabel,
  templateValueLabel,
  onReset,
}: ProfileEditFieldOverrideHintProps) {
  const display = getFieldOverrideDisplay(fieldKey);

  return (
    <TemplateCustomizationHint
      customized={display.customized}
      message={overrideHintMessage}
      resetLabel={resetLabel}
      templateValueLabel={templateValueLabel}
      templateValue={display.templateValue}
      templateDetails={display.templateDetails}
      onReset={() => onReset(fieldKey)}
      className="mt-1.5"
    />
  );
}
